import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaUser } from 'react-icons/fa';
import logo from '../assets/logo.svg';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isLightPage = ['/login', '/register', '/careers', '/events', '/support', '/about', '/products'].includes(location.pathname);
  const linkColor = isLightPage ? 'text-dark' : 'text-white';

  return (
    <nav className="navbar navbar-expand-md navbar-dark px-4 py-3">
      <div className="container-fluid d-flex align-items-center">
        <Link className="navbar-brand me-2" to="/">
          <img src={logo} alt="Loopstudios Logo" className="logo-img" />
        </Link>
        <button
          className="navbar-toggler ms-auto"
          type="button"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}>
          <ul className={`navbar-nav ms-auto mb-2 mb-md-0 ${linkColor}`}>
            {['Home','About', 'Careers', 'Events', 'Products', 'Support'].map((item) => (
              <li key={item} className="nav-item">
                <Link
                  to={item === 'Creations' ? '/' : `/${item.toLowerCase()}`}
                  className={`nav-link ${linkColor} hover-text-gray`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item}
                </Link>
              </li>
            ))}
            <li className="nav-item">
              <Link
                to="/login"
                className={`nav-link ${linkColor} hover-text-gray d-flex align-items-center`}
                onClick={() => setIsMenuOpen(false)}
              >
                <FaUser className="me-1" /> User
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;